import CouponExpired from './CouponExpired';
import CouponNotFound from './CouponNotFound';

type Props = {
  couponExpired: boolean;
  expiresAt: string;
};

export function InvalidCoupon({ couponExpired, expiresAt }: Props): React.ReactElement {
  return couponExpired ? <CouponExpired expiresAt={expiresAt} /> : <CouponNotFound />;
}
